import { TodoPriority, TodoSearchSortBy } from "@graphql";
import moment from "moment";
import locale from "@bonliva-crm/locale";

export const TICKETS_PRIORITY = {
  [TodoPriority.High]: locale.tickets.priorities.High,
  [TodoPriority.Low]: locale.tickets.priorities.Low
};

export enum ConsultantSITHSErrand {
  OrderCard = "OrderCard",
  ExitCard = "ExitCard"
}

export enum ConsultantEducationType {
  HLR = "HLR",
  SHLR = "S-HLR",
  AHLR = "A-HLR"
}

export enum TicketsFiltersList {
  Text = "text",
  CreatedBy = "createdBy",
  DelegatedBy = "delegatedBy",
  AssignedTo = "assignedTo",
  ManagedBy = "managedBy",
  DueDate = "dueDate",
  Category = "category",
  Completed = "cempleted",
  deleted = "deleted",
  Tags = "tags",
  Status = "status",
  Priority = "priority"
}

export const enum normalizationType {
  startOf = "startOf",
  endOf = "endOf"
}
export const dateNormalization = (
  date: Date | null,
  type: normalizationType
): Date | null => {
  if (date) {
    switch (type) {
      case normalizationType.startOf:
        return moment(date).utc().startOf("day").toDate();
      case normalizationType.endOf:
        return moment(date).utc().endOf("day").toDate();
    }
  }
  return null;
};

export const educationTypeOptions = Object.values(ConsultantEducationType).map(
  (value) => ({
    label: value,
    value
  })
);

export const errandOptions = [
  {
    label: locale.tickets.orderSITHSCard,
    value: ConsultantSITHSErrand.OrderCard
  },
  {
    label: locale.tickets.exitSITHSCard,
    value: ConsultantSITHSErrand.ExitCard
  }
];

export const sortOptionDataBlank = [
  {
    active: true,
    label: locale.ticketsCard.sortCreateDesc,
    value: `${TodoSearchSortBy.Create}_-1`
  },
  {
    active: false,
    label: locale.ticketsCard.sortCreateAsc,
    value: `${TodoSearchSortBy.Create}_1`
  },
  {
    active: false,
    label: locale.ticketsCard.sortDue,
    value: `${TodoSearchSortBy.Due}_1`
  }
];
